//src/components/EditProperty.Utils.jsx
export { formatRupiah, formatRupiahInput, normalizeNumber, validateStep } from './sellProperty.utils';

export const buildUpdatePayload = (form, propertyImages) => {
    const payload = new FormData();

    const append = (key, value) => {
        if (value === undefined || value === null || value === '') return;
        payload.append(key, value);
    };

    // Method spoofing for Laravel
    payload.append('_method', 'PUT');

    // Basic fields
    append('property_type_id', form.property_type_id);
    append('certificate_type_id', form.certificate_type_id);

    append('title', form.title);
    append('excerpt', form.excerpt);
    append('description', form.description);

    // Normalize price
    const priceRaw = String(form.price || '').replace(/[^\d]/g, '');
    append('price', priceRaw);

    append('status', form.status);
    append('sale_rent_duration', form.sale_rent_duration);

    // Location
    append('location', form.location);
    append('address', form.address);
    append('city', form.city);
    append('province', form.province);
    append('district', form.district);
    append('village', form.village);
    append('latitude', form.latitude);
    append('longitude', form.longitude);

    // Property specs
    const normalizeNumber = (v) => (v === null || v === undefined || v === '' ? '' : String(v).replace(/[^\d]/g, ''));

    append('building_area', normalizeNumber(form.building_area));
    append('land_area', normalizeNumber(form.land_area));
    append('bedrooms', normalizeNumber(form.bedrooms));
    append('bathrooms', normalizeNumber(form.bathrooms));
    append('floors', normalizeNumber(form.floors));

    append('construction_year', normalizeNumber(form.construction_year));
    append('renovation_year', normalizeNumber(form.renovation_year));
    append('garage_count', normalizeNumber(form.garage_count));
    append('carport_count', normalizeNumber(form.carport_count));
    append('furnishing_status', form.furnishing_status);
    append('electric_power', normalizeNumber(form.electric_power));
    append('building_orientation', form.building_orientation);
    append('building_condition', form.building_condition);

    // Features
    (form.feature_ids || []).forEach((featureId) => {
        payload.append('feature_ids[]', String(featureId));
    });

    // Nearby places
    (form.nearby_places || []).forEach((place, index) => {
        if (!place) return;
        payload.append(`nearby_places[${index}][category]`, place.category || '');
        payload.append(`nearby_places[${index}][name]`, place.name || '');
        payload.append(`nearby_places[${index}][address]`, place.address || '');

        if (place.distance_km !== '' && place.distance_km !== null && place.distance_km !== undefined) {
            payload.append(`nearby_places[${index}][distance_km]`, String(place.distance_km));
        }

        payload.append(`nearby_places[${index}][sort_order]`, String(place.sort_order ?? index));
    });

    // Property specifications
    if (form.property_specifications?.length) {
        form.property_specifications.forEach((spec, index) => {
            payload.append(`property_specifications[${index}][icon]`, spec.icon || '');
            payload.append(`property_specifications[${index}][specification_type]`, spec.specification_type || '');
        });
    }

    const activeImages = (propertyImages || []).filter((img) => !img.toDelete);
    let primaryImageIndex = null;
    let newFileIndex = 0;

    // Send existing image IDs to keep (in order)
    const existingToKeep = activeImages.filter((img) => img.isExisting && img.id);
    existingToKeep.forEach((img) => {
        payload.append('existing_image_ids[]', String(img.id));
    });

    // Send new file uploads
    const newImages = activeImages.filter((img) => !img.isExisting && img.file);
    newImages.forEach((item) => {
        payload.append('images[]', item.file);
    });

    if (activeImages.length > 0) {
        payload.append('primary_image_index', '0');
    }

    return payload;
};
